<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <button style="margin-top: 10px" class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="createNewDialog"><i class="fa fa-fw fa-plus"></i> {{ _('New template') }}</button>
          <h3><i class="fa fa-fw fa-file-text"></i> {{ _('Templates') }}</h3>
        </div>
      </div>
      <Datatable :url="templatesUrl" :search="search" :options="tableOptions" ref="datatable" v-on:data="tableEvent" />
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable } from '#components'
import debounce from 'lodash/debounce'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      templates: [],
      search: '',
      tableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 4,
          responsive: 0
        },
        {
          title: _('Type'),
          field: 'type',
          widthGrow: 4,
          formatter: this.templateTypeFormatter()
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }],
        rowClick (e, row) {
          $this.editRow(row)
        }
      }
    }
  },
  mixins: [components, formatters],
  computed: {
    templatesUrl () {
      return this.baseDomain + this.shopId + '/templates.json?apikey=' + this.apiKey
    }
  },
  methods: {
    editRow (row) {
      let id = row.getCell('id').getValue()
      let name = row.getCell('name').getValue()
      this.editTemplate(id, name)
    },
    editTemplate (id, name, skipState) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'TemplateDetails',
        title: this._('Template') + ' ' + id + (name ? ': ' + name : ''),
        width: 6,
        data: {
          templateId: id
        },
        skipState
      })
    },
    createNewDialog () {
      this.showDialog({
        title: this._('New template'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'save',
            requiredFields: ['name', 'type'],
            handler: this.createNew
          }
        ],
        fields: [
          {
            title: this._('Name'),
            type: 'text',
            name: 'name'
          },
          {
            title: this._('Type'),
            type: 'select',
            name: 'type',
            options: [
              {
                value: 'posreceipt.tpl',
                name: this._('POS receipt')
              },
              {
                value: 'posticket.tpl',
                name: this._('POS ticket')
              },
              {
                value: 'bocaticket.tpl',
                name: this._('POS ticket') + ' (BOCA)'
              },
              {
                value: 'pdfvaluecard.tpl',
                name: this._('PDF value card')
              },
            ]
          }
        ]
      })
    },
    async createNew (data) {
      let response
      let d = {
        name: data.name,
        type: data.type
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/templates.json?apikey=' + this.apiKey, d)
        if (response.data) {
          this.editTemplate(response.data, data.name)
        }
      } catch(e) {
        this.showError(e)
      }
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['templateUpdate'] = debounce((message) => {
        return this.reload()
      }, 200)
      events['restoreDetails'] = (message) => {
        if (message.shopId !== this.shopId) {
          return
        }
        switch(message.component) {
          case 'TemplateDetails':
            this.editTemplate(message.data.templateId, null, true)
            break
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>